<template>
  <div class="login">
    <div class="login_title">信华利筑项管平台</div>
    <div class="form">
      <el-form ref="form" :model="form" label-width="0">
        <div>
          <el-form-item
            class="phone"
            prop="mobile"
            :rules="[
              { required: true, message: '请输入手机号码', trigger: 'blur' },
              {
                pattern: phoneReg,
                message: '请输入正确的手机号码',
                trigger: 'change',
              },
            ]"
          >
            <el-input class="phone" clearable v-model.trim="form.mobile" placeholder="请输入手机号码"> </el-input>
            <el-checkbox v-model="isactive" :true-label="1" :false-label="0">动态登录</el-checkbox>
          </el-form-item>
          <el-form-item v-if="isactive" prop="code" class="code" :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]">
            <el-input clearable placeholder="请输入验证码" v-model.trim="form.code"> </el-input>
            <el-button type="primary" v-if="seconds == '' || seconds == 60" @click="sendCode">获取验证码 </el-button>
            <el-button type="primary" v-else @click="sendCode">{{ seconds }}s后重新获取</el-button>
          </el-form-item>
          <el-form-item v-if="!isactive" prop="user_pwd" :rules="[{ required: true, message: '请输入', trigger: 'change' }]">
            <el-input placeholder="请输入密码" show-password v-model.trim="form.user_pwd"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleLogin" class="submit" type="primary">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="bottom">
      <a>
        <span style="color: #666">还没有账号，</span>
        <span @click="goSign">前往注册 >></span>
      </a>
      <a v-show="!isactive" @click.stop="forgetPwd">忘记密码</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'subLogin',
  props: {
    loginType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {},
      isactive: false,
      isRead: 0,
      seconds: '60',
      active: 0,
      phoneReg: /^1[3456789]\d{9}$/,
    };
  },
  methods: {
    // 登录-提交
    handleLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loginReq();
        }
      });
    },

    loginReq() {
      let data = {
        mobile: this.form.mobile,
      };
      if (this.isactive) {
        data.code = this.form.code;
        data.type = 2;
      } else {
        data.user_pwd = this.form.user_pwd;
        data.type = 4;
      }
      this.$request
        .post('/individual/login', data)
        .then((res) => {
          this.$message.success('登录成功');
          console.log('登录成功', res);
          const user = res.data;
          sessionStorage.setItem('newVersion', 1);
          sessionStorage.setItem('navs', '个人');
          sessionStorage.setItem('token', res.token);
          sessionStorage.setItem('rule', JSON.stringify(res.rule));
          sessionStorage.setItem('userInfo', JSON.stringify(user));
          if (user.pc_first_logon == 0) {
            sessionStorage.setItem('firstLogin', true);
          }
          this.$bus.$emit('setNew', true);
          console.log('this.loginType', this.loginType);
          const url = this.loginType == 2 ? '/personMag/index/company' : this.loginType == 1 ? '/personMag/index/project' : '/personMag/index';
          console.log('url', url);
          this.$router.push(url);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    // 获取验证码
    sendCode() {
      if (!this.phoneReg.test(this.form.mobile)) return this.$message.error('请输入正确的手机号');

      this.getCode();
      this.$request
        .post('/collective/sms/sendCode', {
          mobile: this.form.mobile,
          type: 'login',
        })
        .then((res) => {
          this.$message.success('发送成功');
        });
    },

    // 登录方式切换
    goSign() {
      this.$emit('gosign');
    },
    forgetPwd() {
      this.$emit('gopass');
    },
    // 获取验证码显示倒计时
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.seconds = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.seconds > 0 && this.seconds <= TIME_COUNT) {
            this.seconds--;
          } else {
            this.seconds = '60';
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  margin: 0 auto;
  position: relative;
  align-self: center;

  .login_title {
    font-size: 36px;
    font-weight: 700;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    margin-bottom: 24px;
  }
}

.form {
  /deep/ .el-input {
    width: 490px;
    font-size: 18px;
    border-radius: 4px;

    .el-input__inner {
      width: 100%;
      height: 56px;
      color: #333333;
    }
    .el-input__inner::placeholder {
      color: #999999;
      font-size: 18px;
    }
  }
}

/deep/ .el-form-item__label {
  text-align: left;
  color: #262626;
}
/deep/.code {
  .el-input {
    width: 320px;
  }
  .el-button--primary {
    background-color: #ffffff;
    color: #1b70ff;
    width: 154px;
    height: 54px;
    margin-left: 16px;
    border-radius: 4px;
  }
}

/deep/ .phone {
  .el-input {
    width: 314px;
  }
  .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-autocomplete {
    width: 314px;
  }
  .el-checkbox {
    width: 164px;
    height: 53px;
    margin-left: 10px;
    border-radius: 4px;
    border: 1px solid rgba(27, 112, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1b70ff;
  }
}

.submit {
  width: 490px;
  margin-top: 20px;
  background: #1b70ff;
  color: #ffffff;
  height: 60px;
  font-size: 24px;
}

//   .left {
//     // margin-left: 36px;
//     .blue-font {
//       cursor: pointer;
//       color: #1b70ff;
//     }
//     .mr-6 {
//       margin-right: 6px;
//     }
//   }
// }
.bottom {
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
  margin: 30px 30px 10px;
  color: #1b70ff;
  cursor: pointer;
  padding: 0 72px;
}
</style>
<style>
.login .el-form-item__error {
  position: absolute;
  top: 100%;
  left: 100px;
}
</style>
